import { useCallback, useState } from 'react'

export interface IUseControlledOrUncontrolledState<TState> {
  controlledState?: TState
  defaultInternalState: TState
}

export const useControlledOrUncontrolledState = <T>({
  controlledState,
  defaultInternalState,
}: IUseControlledOrUncontrolledState<T>) => {
  // Internal state for uncontrolled mode
  const [internalState, setInternalState] = useState(defaultInternalState)

  const isControlled = controlledState !== undefined

  // Function to set state, only affects internal state in uncontrolled mode
  const setUncontrolledState = useCallback(
    (newState: T) => {
      if (!isControlled) {
        setInternalState(newState)
      } else {
        throw new Error('You cannot call setUncontrolledState when the component is controlled')
      }
    },
    [isControlled],
  )

  // Return the current state (controlled or uncontrolled) and the function to update it
  return {
    isControlled,
    state: isControlled ? controlledState : internalState,
    setUncontrolledState,
  }
}
